import { Trans } from '@lingui/react'
import { CartEntryItemERxV2PriceLabelInfoEnum } from '@redteclab/api/clients/bully'
import type { FunctionComponent } from 'react'

import Notification, {
  NOTIFICATION_TYPES,
} from 'views/components/molecules/Notification'

import './ErxPriceLabelInfo.scss'

const ErxPriceLabelInfoMap = {
  [CartEntryItemERxV2PriceLabelInfoEnum.PriceBetween020]: (
    <Trans
      id="cart.notification.erx.priceLabelInfo.priceBetween020"
      components={{
        span: <span className="a-ErxPriceLabelInfo__text--italic" />,
      }}
    />
  ),
  [CartEntryItemERxV2PriceLabelInfoEnum.CallInAnyCase]: (
    <Trans
      id="cart.notification.erx.priceLabelInfo.callInAnyCase"
      components={{
        strong: <strong className="a-ErxPriceLabelInfo__title" />,
        br: <br />,
        span: <span className="a-ErxPriceLabelInfo__text--italic" />,
      }}
    />
  ),
  [CartEntryItemERxV2PriceLabelInfoEnum.CallIfGreaterThan50]: (
    <Trans
      id="cart.notification.erx.priceLabelInfo.callIfGreaterThan50"
      components={{
        span: <span className="a-ErxPriceLabelInfo__text--italic" />,
      }}
    />
  ),
}

interface ErxPriceLabelInfoProps {
  priceLabelInfo: CartEntryItemERxV2PriceLabelInfoEnum
}

const ErxPriceLabelInfo: FunctionComponent<ErxPriceLabelInfoProps> = ({
  priceLabelInfo,
}: ErxPriceLabelInfoProps) => {
  return (
    <Notification
      dataQaId={`erx-price-label-info-${priceLabelInfo}`}
      type={NOTIFICATION_TYPES.WARNING}
      label={
        ErxPriceLabelInfoMap[
          priceLabelInfo as CartEntryItemERxV2PriceLabelInfoEnum
        ]
      }
      hasNoIcon
    />
  )
}

export default ErxPriceLabelInfo
